"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFirstMountState = void 0;
const react_1 = require("react");
/**
 * Returns a boolean that is `true` only on first render.
 */
function useFirstMountState() {
    const isFirstMount = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        isFirstMount.current = false;
    }, []);
    return isFirstMount.current;
}
exports.useFirstMountState = useFirstMountState;
